import { SavingsDepositDialogContentContainer } from './SavingsDepositDialogContentContainer'
import { Token } from '@/domain/types/Token'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface SavingsDepositDialogProps extends CommonDialogProps {
  initialToken: Token
  savingsToken: Token
  chainId?: number
  onSuccess?: () => void
}

function SavingsDepositDialog({ open, setOpen, ...props }: SavingsDepositDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <SavingsDepositDialogContentContainer closeDialog={() => setOpen(false)} {...props} />
      </DialogContent>
    </Dialog>
  )
}

export const savingsDepositDialogConfig = {
  options: {
    closeOnAccountChange: true,
  },
  element: SavingsDepositDialog,
  name: 'SavingsDepositDialog',
} satisfies DialogConfig<SavingsDepositDialogProps>
